import { createActions } from 'reduxsauce'
import { getHTTPClient, showNotification, checkStatusCode } from 'helpers'

export const { Types, Creators } = createActions({
    fetchMovimentacaoReportBegin: null,
    fetchMovimentacaoReportSuccess: ['payload'],
    fetchMovimentacaoReportFailure: null,
})

export const fetchMovimentacaoReport = componentState => dispatch => {
    dispatch(Creators.fetchMovimentacaoReportBegin())
    return getHTTPClient()({
        method: 'POST',
        url: '/reports',
        data: componentState
    })
    .then(response => dispatch(Creators.fetchMovimentacaoReportSuccess(response.data)))
    .catch(error => {
        checkStatusCode(error.response.status)
        if (error.response) {
            showNotification(error.response.data.message, 'alert-danger')
        } else if (error.request) {
            if (process.env.NODE_ENV === 'development' )
                console.log(error.request)
                showNotification('Ops, algo deu errado, tente novamente em instantes.', 'alert-danger')
        } else {
            showNotification(error.message, 'alert-danger')
        }
        return dispatch(Creators.fetchMovimentacaoReportFailure())
    })
}